export default __webpack_public_path__ + "locales/es/ConvertDialog.json?hash=904168c6b98e9be86fc5643b6b94df54";